class ProductSummary {
  #summaryElement;

  #body = document.body;

  constructor() {
    this.#summaryElement = document.querySelector(".js-product-summary");

    if (!this.#summaryElement) return;

    this.onWindowScroll = this.onWindowScroll.bind(this);

    window.addEventListener("scroll", this.onWindowScroll);

    this.#setSummaryMinHeight();
  }

  #setSummaryMinHeight() {
    this.#summaryElement.style.minHeight = `${this.#summaryElement.scrollHeight}px`;
  }

  onWindowScroll() {
    const elementBottomRect = this.#summaryElement.getBoundingClientRect().bottom;
    elementBottomRect > 50 ? this.#setSummaryMinHeight() : null;
    if (elementBottomRect > 50) {
      this.#setSummaryMinHeight();
      this.#body.removeAttribute("data-product-summary");
    } else {
      this.#body.setAttribute("data-product-summary", "");
    }

    this.#summaryElement.setAttribute("data-is-visible", elementBottomRect > 50);
  }
}

export {ProductSummary};
